import { t } from '@lingui/macro';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { onChangeLoginForm } from '../../../ac/onChangeLoginForm';
import { onResetDefaultPassword } from '../../../ac/onResetDefaultPassword';
import { useSpinner } from '../../../hooks/useSpinner';
import { ButtonWithSpinner } from '../../Buttons/ButtonWithSpinner';
import { LoginFormInput } from '../LoginFormInput';
import styles from '../LoginForms.module.css';

const ResetDefaultPasswordFormComponent = ({
    loginForm,
    onChangeLoginForm,
    onResetDefaultPassword,
}) => {
    const [ isSendingRequest, onSubmit ] = useSpinner(async e => {
        e.preventDefault();
        await onResetDefaultPassword();
    });
    return (
        <form
            className={styles.authForm}
            onSubmit={onSubmit}
        >
            <Typography
                variant='overline'
                className={styles.title}
            >
                {t`Измените ваш пароль по умолчанию`}
            </Typography>
            <LoginFormInput
                id='newPassword'
                type='password'
                onChange={onChangeLoginForm}
                value={loginForm.newPassword}
            >
                {t`Новый пароль`}
            </LoginFormInput>
            <ButtonWithSpinner
                type='submit'
                isLoading={isSendingRequest}
                className={styles.signInButton}
            >
                {t`Изменить`}
            </ButtonWithSpinner>
        </form>
    );
};
const mapStateToProps = ({ loginForm }) => ({ loginForm });
export const ResetDefaultPasswordForm = connect(mapStateToProps, {
    onChangeLoginForm, onResetDefaultPassword,
})(ResetDefaultPasswordFormComponent);
